import { useState } from 'react';
import { faqs } from '@/mocks/comics';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_1.4fr] lg:gap-12">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-bold text-secondary-800">
            <i className="ri-question-answer-line" />
            常见问题
          </span>
          <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">关于咪咕漫画网的疑问</h2>
          <p className="mt-2 text-sm text-foreground-600 md:text-base">
            关于手机版阅读、APP 下载、安卓版与 iOS 版使用等问题，这里都有答案。如果还有疑问，欢迎通过页脚联系方式与我们沟通。
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((item, index) => {
            const open = openIndex === index;
            return (
              <div
                key={item.q}
                className={`overflow-hidden rounded-lg border transition-colors ${
                  open ? 'border-primary-200 bg-primary-50/40' : 'border-background-200/70 bg-background-100'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : index)}
                  className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left"
                  aria-expanded={open}
                >
                  <span className="text-sm font-bold text-foreground-950 md:text-base">{item.q}</span>
                  <i
                    className={`ri-add-line shrink-0 text-lg text-primary-600 transition-transform duration-300 ${
                      open ? 'rotate-45' : ''
                    }`}
                  ></i>
                </button>
                {open && (
                  <div className="px-4 pb-4 text-sm leading-relaxed text-foreground-700">{item.a}</div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}